<template>
    <section style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    ">
        <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-row>
                    <v-col cols="12" sm="12" md="3">
                        <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
                            <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
                            Ajouter une actualité à {{ serie.label }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog v-model="addCard" max-width="1000">
            <v-card class="pa-6 pa-sm-6">
                <v-form ref="form" lazy-validation>
                    <v-card-title class="d-flex justify-space-between align-center">
                        <span>Ajouter une actualité à {{ serie.label }}</span>
                        <v-btn icon @click="addCard = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="mt-4">
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="title" label="Titre" outlined required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="titleEn" label="Titre en anglais" outlined
                                    required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="overview" label="Overview" outlined required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="overviewEn" label="Overview en anglais" outlined
                                    required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="highlight" label="Highlight" outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="highlightEn" label="Highlight en anglais"
                                    outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field v-if="highlight.length > 0" v-model="reportBy" label="Rapporté par"
                                    outlined :required="isReportByRequired"></v-text-field>
                            </v-col>
                            <template v-if="
                                $route.params.category !== 'PERSONNAGE' &&
                                $route.params.category !== 'PATRIMOINE'
                            ">
                                <v-col cols="12" sm="12" md="6">
                                    <VueEditor v-model="description" auto-grow outlined label="Description"
                                        placeholder="Description">
                                    </VueEditor>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <VueEditor v-model="descriptionEn" auto-grow outlined label="Description en anglais"
                                        placeholder="Description en anglais"></VueEditor>
                                </v-col>
                            </template>
                            <v-col cols="12">
                                <v-text-field v-model="actualityRank" label="Rang" outlined required type="number"
                                    min="0"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="Tags en francais" v-model="actualityInfo.TagsTextFr" outlined
                                    required></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="Tags en anglais" v-model="actualityInfo.TagsTextEn" outlined
                                    required></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="showTagsError && tagsfrList.length !== tagsEnList.length">
                                <v-alert type="error" dense class="mb-0">
                                    Erreur : Le nombre de tags en français ({{ tagsfrList.length }}) et en anglais ({{ tagsEnList.length }}) doit être identique !
                                </v-alert>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" v-if="title && titleEn">
                                <vue-upload-multiple-image :idUpload="imagesId" v-model="images" :data-images="images"
                                    accept="image/*	" name="images" drag-text="Veuillez ajoutez une image"
                                    browse-text="Browse image" primary-text="Primary image"
                                    mark-is-primary-text="Set default image" :min-image="1" :multiple="false"
                                    :showEdit="false" popup-text="Description default image" drop-text="Drag and drop"
                                    @upload-success="uploadImageSuccess" @before-remove="beforeRemove"
                                    @images-updated="handleImagesUpdated">
                                </vue-upload-multiple-image>
                                <v-progress-linear v-if="showlowding && uploadPercentage < 100" style="max-width: 190px"
                                    color="primary" indeterminate rounded height="15"><strong>{{
                                        Math.ceil(uploadPercentage)
                                        }}%</strong></v-progress-linear>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-row align="center">
                                    <v-col cols="auto" style="margin-top: 16px">
                                        <span>Premium:</span>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-switch v-model="Premium" hide-details inset></v-switch>
                                    </v-col>
                                    <v-col cols="auto" style="margin-top: 16px">
                                        <v-icon color="#00a325" v-if="!Premium">
                                            {{ icons.mdiLockOpen }}
                                        </v-icon>
                                        <v-icon color="warning" v-if="Premium">
                                            {{ icons.mdiLock }}
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-row align="center">
                                    <v-col cols="auto" style="margin-top: 16px">
                                        <span>certified :</span>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-switch v-model="certified" hide-details inset></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="certified">
                                <v-select v-model="authorSelected" clearable label="Author" :items="authorList"
                                    item-text="name" item-value="id" outlined></v-select>
                            </v-col>

                            <v-col cols="12" sm="12" md="6">
                                <v-switch v-model="isScheduled" label="Programmer l'actualité ?" inset
                                    color="primary"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" v-if="isScheduled">
                                <v-text-field type="datetime-local" outlined v-model="scheduledDateTime"
                                    label="Date & Heure de programmation" :min="minDateTime" required></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12" md="12" v-if="
                                $route.params.category === 'PERSONNAGE' ||
                                $route.params.category === 'PATRIMOINE'
                            ">
                                <div class="d-flex flex-row-reverse">
                                    <v-btn :disabled="title.length <= 0 ||
                                        overview.length <= 0 ||
                                        titleEn.length <= 0 ||
                                        overviewEn.length <= 0 || (isReportByRequired && !reportBy)
                                        " class="info" @click="ajoutactuality()">
                                        Suivant
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-else-if="$route.params.category === 'ARTICLE'">
                                <div class="d-flex flex-row-reverse">
                                    <v-btn :disabled="title.length <= 0 ||
                                        titleEn.length <= 0 ||
                                        overview.length <= 0 ||
                                        overviewEn.length <= 0 ||
                                        description.length <= 0 ||
                                        descriptionEn.length <= 0 || (isReportByRequired && !reportBy)
                                        " class="info" @click="ajoutactuality()">
                                        Suivant
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-else>
                                <div class="d-flex flex-row-reverse">
                                    <v-btn @click="ajoutactuality()" color="info darken-1"
                                        :disabled="!canSubmitActuality() || isButtonDisabled">
                                        Confirmer
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>
        <v-card class="mb-6 ml-6 mt-6 mr-2">
            <v-card-title class="d-flex align-center justify-space-between">
                <span>{{ serie.label }}</span>
                <v-btn color="primary" small @click="dialogAssignActuality = true">
                    <v-icon left>{{ icons.mdiPlus }}</v-icon>
                    Affecter une actualité
                </v-btn>
            </v-card-title>
            <v-data-table :loading="isLoadingTables" loading-text="Loading..." :footer-props="{
                'items-per-page-options': [5, 10, 15, 30],
            }" class="elevation-1" item-key="id" :headers="header" :items="actualityList">
                <template v-slot:[`item.dateOfPublish`]="{ item }">
                    {{ formatDateOfPublish(item.dateOfPublish) }}
                </template>
                <template v-slot:[`item.published`]="{ item }">
                    <v-icon color="#00a325" v-if="item.published">
                        {{ icons.mdiCheck }}
                    </v-icon>
                    <v-icon color="error" v-if="!item.published">
                        {{ icons.mdiCancel }}
                    </v-icon>
                </template>
                <template v-slot:[`item.isLocked`]="{ item }">
                    <v-icon color="primary" v-if="item.isLocked">
                        {{ icons.mdiLock }}
                    </v-icon>
                    <v-icon color="#00a325" v-if="!item.isLocked">
                        {{ icons.mdiLockOpen }}
                    </v-icon>
                </template>
                <template v-slot:[`item.imgUrl`]="{ item }">
                    <v-img v-if="item.imgDBType != 'svg'" :src="item.imgUrl" width="65" height="65" />
                    <div v-if="item.imgDBType === 'svg'" v-html="item.svgContent"></div>

                    <v-divider></v-divider>
                </template>

                <template v-slot:[`item.modifier`]="{ item }">
                    <v-icon @click="redirectToEditActuality(item)">
                        {{ icons.mdiPencil }}
                    </v-icon>
                </template>
                <template v-slot:[`item.visualiser`]="{ item }">
                    <v-icon v-if="isArticleCategory" @click="redirectToVisualiserActuality(item)">
                        {{ icons.mdiEye }}
                    </v-icon>
                </template>
                <template v-slot:[`item.supprimer`]="{ item }">
                    <v-icon @click="suppressionAction(item.id)">
                        {{ icons.mdiDeleteOutline }}
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-card class="mb-6 ml-6 mt-6 mr-2">
            <v-card-title class="d-flex align-center justify-space-between py-3 px-4">
                <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-calendar-month</v-icon>
                    <span class="card-title font-weight-bold text-h6 primary--text">Calendrier des Actualités</span>
                </div>
                <div class="d-flex align-center">
                    <v-btn outlined small class="mr-2" color="grey darken-2" @click="setToday">
                        Aujourd'hui
                    </v-btn>
                    <v-btn fab text x-small color="grey darken-2" class="mr-1" @click="prev">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn fab text x-small color="grey darken-2" class="mr-4" @click="next">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>

                    <v-select v-model="calendarType" :items="calendarTypes" dense outlined hide-details
                        class="mr-4 select-calendar-type" style="max-width: 120px"></v-select>
                    <!--
          <v-btn color="primary" @click="openScheduleForm(null)">
            <v-icon left>mdi-plus</v-icon>
            Programmer
          </v-btn>
          -->
                </div>
            </v-card-title>

            <v-card-text>
                <div
                    class="calendar-title-display text-h5 font-weight-medium text-center my-3 grey--text text--darken-2">
                    {{ calendarTitle }}
                    <div class="text-subtitle-2 grey--text mt-1" v-if="calendarStart && calendarEnd">
                        Période : du {{ formatSimpleDate(calendarStart) }} au {{ formatSimpleDate(calendarEnd) }}
                    </div>
                </div>
                <v-sheet height="600" class="calendar-sheet">
                    <v-calendar ref="calendar" v-model="calendarFocus" color="primary" :events="scheduledEvents"
                        :type="calendarType" locale="fr" :weekdays="[1, 2, 3, 4, 5, 6, 0]" event-more-text="{0} de plus"
                        @click:event="showEventDetails" @click:date="onDateClick"
                        @change="onCalendarChange"></v-calendar>
                </v-sheet>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialogAssignActuality" max-width="800px">
            <v-card>
                <v-card-title>Affecter une actualité à la série {{ serie.label }}</v-card-title>
                <v-card-text>
                    <v-autocomplete v-model="selectedActualityId" :items="actualityWithoutSubCategoryList"
                        item-text="title" item-value="id" label="Actualité" placeholder="Rechercher une actualité"
                        no-data-text="Aucune actualité sans série disponible" clearable outlined />
                    <v-alert v-if="assignmentError" type="error" dense class="mb-0">
                        {{ assignmentError }}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogAssignActuality = false" :disabled="isAssigningActuality">
                        Annuler
                    </v-btn>
                    <v-btn color="primary" :loading="isAssigningActuality"
                        :disabled="selectedActualityId === null || selectedActualityId === ''" @click="assignActuality">
                        Affecter
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
import { FetchActualityByCategoryAndSubCategory, FetchActualityWithoutSubCategory, FetchAllTags, FetchSubCategoryById } from '@/views/qorani/services/services';
import {
    mdiPlus,
    mdiDeleteOutline,
    mdiPencil,
    mdiEye,
    mdiDatabasePlusOutline,
    mdiLockOpen,
    mdiLock,
    mdiCheck,
    mdiCancel
} from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { component as VueCodeHighlight } from "vue-code-highlight";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";

import constants from '@/utils/constants';
import axios from 'axios';
import store from '@/store/image';

export default {
    components: { VueUploadMultipleImage, VueEditor, VueCodeHighlight },

    data() {
        return {
            calendarFocus: new Date().toISOString().slice(0, 10),

            actualityIdSupprimmer: null,
            actualityInfo: {
                title: "",
                titleEn: "",
                overview: "",
                overviewEn: "",
                subtitle: "",
                subtitleEn: "",
                description: "",
                descriptionEn: "",
                actualitySubCategoryId: null,
                isLocked: false,
                actualityCategoryId: "",
                imgUrl: null,
                imgBannerUrl: null,
                imgUrlDBId: null,
                imgBannerUrDBlId: null,
                scheduledDateTime: null,
                TagsTextFr: "",
                TagsTextEn: "",
            },
            calendarType: "month",
            calendarTypes: [
                { text: "Mois", value: "month" },
                { text: "Semaine", value: "week" },
                { text: "Jour", value: "day" },
            ],

            calendarFocus: new Date().toISOString().slice(0, 10),
            calendarTitle: "",

            calendarStart: "",
            calendarEnd: "",
            scheduledEvents: [],
            imagesId: "1",
            images: [],
            imagesUpload: [],
            showlowding: false,
            isButtonDisabled: false,
            title: "",
            titleEn: "",
            overview: "",
            overviewEn: "",
            highlight: "",
            highlightEn: "",
            reportBy: "",
            description: "",
            descriptionEn: "",
            actualityRank: 0,
            tagsArray: [],
            selectTags: [],
            subtitle: "",
            subtitleEn: "",
            Premium: false,
            isScheduled: false,
            imgUrlDBId: null,
            certified: false,
            addCard: false,
            showTagsError: false,
            isLoadingTables: false,
            dialogAssignActuality: false,
            isAssigningActuality: false,
            selectedActualityId: null,
            assignmentError: '',
            serie: '',
            icons: {
                mdiPlus,
                mdiDeleteOutline,
                mdiPencil,
                mdiEye,
                mdiDatabasePlusOutline,
                mdiLockOpen,
                mdiLock,
                mdiCheck,
                mdiCancel
            },

            actualityList: [],
            actualityWithoutSubCategoryList: [],
            header: [
                { text: "Image", value: "imgUrl" },
                { text: "Titre", value: "title" },
                { text: "Titre En anglais", value: "titleEn" },
                { text: "Overview", value: "overview" },
                { text: "Overview En anglais", value: "overviewEn" },
                { text: "Sous-Titre", value: "subtitle" },
                { text: "Sous-Titre en anglais", value: "subtitleEn" },
                { text: "Date de publication", value: "dateOfPublish" },
                { text: "Publier", value: "published", align: "center" },
                { text: "Premium", value: "isLocked" },
                { text: "Rang", value: "actualityRank" },
                { text: "Modifier", value: "modifier", align: "center" },
                { text: "Supprimer", value: "supprimer", align: "center" },
            ],

        };
    },
    methods: {
        async existTag() {
            const tagsfrList = this.tagsfrList;
            const tagsEnList = this.tagsEnList;

            if (tagsfrList.length !== tagsEnList.length) {
                this.showTagsError = true;
                console.error(
                    "Erreur : Les longueurs de TagsTextFr et TagsTextEn ne sont pas égales !"
                );
                return false;
            }
            this.showTagsError = false;

            if (!this.tagsArray || this.tagsArray.length === 0) {
                this.tagsArray = (await FetchAllTags()) || [];
            }

            const tagsid = [];

            for (let i = 0; i < tagsfrList.length; i++) {
                const titleFr = tagsfrList[i];
                const titleEn = tagsEnList[i];

                const existingTag = (this.tagsArray || []).find(
                    (tag) =>
                        (tag.title &&
                            tag.title.trim().toLowerCase() === titleFr.toLowerCase()) ||
                        (tag.titleEn &&
                            tag.titleEn.trim().toLowerCase() === titleEn.toLowerCase())
                );

                if (existingTag) {
                    if (!tagsid.some((id) => String(id) === String(existingTag.id))) {
                        tagsid.push(existingTag.id);
                    }
                } else {
                    try {
                        const missingPayloads = {
                            title: titleFr,
                            titleEn: titleEn,
                        };
                        const response = await axios.post(
                            `${constants.QORANI}tag/add`,
                            missingPayloads
                        );
                        if (response.data && response.data.id) {
                            tagsid.push(response.data.id);
                            if (this.tagsArray) {
                                this.tagsArray.push(response.data);
                            }
                        }
                    } catch (error) {
                        console.error("Erreur lors de l'ajout du tag :", titleFr, error);
                    }
                }
            }

            this.selectTags = [...tagsid];
            if (this.actualityInfo) {
                this.actualityInfo.listTagsIds = [...tagsid];
            }

            console.log("Tags sélectionnés pour l'ajout (IDs):", tagsid);
            return tagsid;
        },
        beforeRemove(index, done, fileList) {
            this.showlowding = false;
            this.uploadPercentage = 0;
            const r = confirm("remove image");
            if (r === true) {
                const indexInArrayImages = this.imagesUpload.indexOf(
                    fileList[index].path
                );
                this.imageUrl = "";
                this.imageId = "";
                if (index > -1) {
                    this.imagesUpload.splice(indexInArrayImages, 1);
                }
                done();
            }
        },

        showEventDetails({ event }) {
            this.selectedEvent = event;
            this.detailsDialog = true;
        },
        onDateClick({ date }) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const clickedDate = new Date(date);
            if (clickedDate < today) {
                return;
            }
            this.openScheduleForm(date);
        },
        formatSimpleDate(dateStr) {
            if (!dateStr) return "";
            try {
                const [year, month, day] = dateStr.split("-");
                return `${day}/${month}/${year}`;
            } catch (e) {
                return dateStr;
            }
        },
        setToday() {
            this.calendarFocus = new Date().toISOString().slice(0, 10);
        },
        prev() {
            this.$refs.calendar.prev();
        },
        next() {
            this.$refs.calendar.next();
        },
        onCalendarChange({ start, end }) {
            if (this.calendarType !== "month" || !start || !end) {
                this.calendarStart = start ? start.date : "";
                this.calendarEnd = end ? end.date : "";
            } else {
                const startDate = new Date(start.date);
                const startDayOfWeek = (startDate.getDay() + 6) % 7;
                const gridStartDate = new Date(startDate);
                gridStartDate.setDate(startDate.getDate() - startDayOfWeek);

                const endDate = new Date(end.date);
                const endDayOfWeek = (endDate.getDay() + 6) % 7;
                const gridEndDate = new Date(endDate);
                gridEndDate.setDate(endDate.getDate() + (6 - endDayOfWeek));

                const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

                this.calendarStart = toISO(gridStartDate);
                this.calendarEnd = toISO(gridEndDate);
            }
            this.$nextTick(() => {
                if (this.$refs.calendar) {
                    this.calendarTitle = this.$refs.calendar.title;
                }
            });
            this.loadScheduledActualities();
        },
        suppressionAction(item) {
            this.actualityIdSupprimmer = item;
            // this.dialogRemoveActuality = true;
            this.deleteActuality();
        },
        async deleteActuality() {
            const response = await fetch(
                constants.QORANI + `actuality/delete/${this.actualityIdSupprimmer}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            try {
                window.location.reload();
            } catch (error) {
                alert(
                    "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
                );
                this.dialogRemoveActuality = false;
            }
        },
        canSubmitActuality() {
            if (!this.actualityInfo.imgUrlDBId) return false;
            if (!this.actualityInfo.imgBannerUrDBlId) return false;
            if (!this.title?.trim() || !this.titleEn?.trim()) return false;
            if (!this.overview?.trim() || !this.overviewEn?.trim()) return false;
            const categoryName = this.$route.params.category || '';
            if (!['PERSONNAGE', 'PATRIMOINE'].includes(categoryName)) {
                if (!this.description?.trim() || !this.descriptionEn?.trim()) return false;
            }
            if (this.isScheduled && !this.scheduledDateTime) return false;
            if ((this.highlight?.trim() || this.highlightEn?.trim()) && !this.reportBy?.trim()) return false;
            if (this.certified && !this.authorSelected) return false;         
            return true;
        },
        formatDateOfPublish(dateTimeStr) {
            if (!dateTimeStr) return "-";
            try {
                const date = new Date(dateTimeStr);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = String(date.getFullYear()).slice(-2);
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                return `${day}:${month}:${year} ${hours}:${minutes}`;
            } catch (e) {
                return dateTimeStr;
            }
        },
        async loadImage(item) {
            if (item.imgDBType === "svg") {
                try {
                    const response = await fetch(
                        `${constants.QORANI}fileDB/files/${item.imgDBId}`
                    );
                    if (!response.ok)
                        throw new Error("Échec du chargement de l'image SVG");

                    let svgContent = await response.text();

                    // Ajoute width et height directement dans le SVG
                    svgContent = svgContent
                        .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
                        .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
                        .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');
                    this.$set(item, 'svgContent', svgContent);
                    item.svgContent = svgContent;
                } catch (error) {
                    console.error("Erreur lors du chargement de l'image :", error);
                }
            } else {
                item.imgUrl = `${constants.QORANI}fileDB/files/${item.imgDBId}`;
            }
        },
        async assignActuality() {
            const actuality = this.actualityWithoutSubCategoryList.find(
                item => item.id === this.selectedActualityId
            );
            if (!actuality) return;

            this.isAssigningActuality = true;
            this.assignmentError = '';
            let payload = {
                "title": actuality.title,
                "overview": actuality.overview,
                "description": actuality.description,
                "titleEn": actuality.titleEn,
                "overviewEn": actuality.overviewEn,
                "descriptionEn": actuality.descriptionEn,
                "isLocked": actuality.isLocked,
                "actualityCategoryId": this.$route.params.categoryid,
                "actualitySubCategoryId": this.$route.params.id,
                "imgUrlDBId": actuality.imgDBId,
                "imgBannerUrDBlId": actuality.imgBannerDBId,
                "authorCertificateId": actuality.author ? actuality.author.id : null,
                "highlight": actuality.highlight,
                "highlightEn": actuality.highlightEn,
                "reportBy": actuality.reportBy,
                "actualityRank": actuality.actualityRank,
            }
            try {

                const response = await axios.post(
                    `${constants.QORANI}actuality/edit/${actuality.id}`, payload
                );

                await this.loadImage(actuality);
                this.actualityList.push(actuality);
                await this.loadScheduledActualities();
                this.actualityWithoutSubCategoryList = this.actualityWithoutSubCategoryList.filter(
                    item => item.id !== actuality.id
                );
                this.selectedActualityId = null;
                this.dialogAssignActuality = false;
            } catch (error) {
                this.assignmentError = error.message || 'Une erreur est survenue lors de l’affectation.';
            } finally {
                this.isAssigningActuality = false;
            }
        },
        redirectToEditActuality(item) {
            this.$router.push({
                name: "EditActuality",
                params: { id: item.id, item: item },
            });
        },
        handleImagesUpdated(images) {
        },
        async ajoutactuality() {
            if (!this.canSubmitActuality()) return;

            const tagSyncSuccess = await this.existTag();
            if (tagSyncSuccess === false) {
                return;
            }

            let nbrSecondLeft = 0;
            if (this.isScheduled) {
                const dateTime = new Date(this.scheduledDateTime);
                const scheduledTimestamp = Math.floor(dateTime.getTime() / 1000);
                const unixTimestamp = Math.floor(Date.now() / 1000);
                nbrSecondLeft = scheduledTimestamp - unixTimestamp;
            }
            console.log(nbrSecondLeft);

            const imageId = store.state.imageId;
            const imageIdBanner = store.state.imageIdBanner;

            this.actualityInfo.title = this.title;
            this.actualityInfo.titleEn = this.titleEn;
            this.actualityInfo.overview = this.overview;
            this.actualityInfo.overviewEn = this.overviewEn;
            this.actualityInfo.subtitle = this.title;
            this.actualityInfo.subtitleEn = this.titleEn;
            this.actualityInfo.description = this.description;
            this.actualityInfo.descriptionEn = this.descriptionEn;
            this.actualityInfo.isLocked = this.Premium;
            this.actualityInfo.actualitySubCategoryId = parseInt(this.$route.params.id);
            this.actualityInfo.actualityCategoryId = parseInt(this.$route.params.categoryid);
            this.actualityInfo.authorCertificateId = this.authorSelected;
            this.actualityInfo.nbrSecondLeft = this.isScheduled ? nbrSecondLeft : 0;
            this.actualityInfo.listTagsIds = this.selectTags;
            this.actualityInfo.highlight = this.highlight;
            this.actualityInfo.highlightEn = this.highlightEn;
            this.actualityInfo.reportBy = this.reportBy;
            this.actualityInfo.actualityRank = this.actualityRank;
            this.isButtonDisabled = true;
            const response = await fetch(constants.QORANI + "actuality/add", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(this.actualityInfo),
            });
            window.location.reload();

        },
        async uploadImageSuccess(formData, index, fileList) {
            try {
                await store.dispatch("uploadImageSuccess", {
                    formData,
                    index,
                    fileList,
                });
                const imageId = store.state.imageId;
                this.actualityInfo.imgUrlDBId = imageId;
                this.actualityInfo.imgBannerUrDBlId = imageId;

                console.log("Image id :", imageId);
            } catch (error) {
                console.error("Failed to upload image:", error);
            }
        },
        async loadScheduledActualities() {
            if (!this.calendarStart || !this.calendarEnd) return;
            try {
                const response = await axios.post(constants.QORANI + "actuality/getAllPerMonth", {
                    id: this.$route.params.categoryid,
                    subCategoryId: this.$route.params.id,
                    startDate: `${this.calendarStart}T00:00:00Z`,
                    endDate: `${this.calendarEnd}T23:59:59Z`
                });

                const list = response.data || [];
                this.scheduledEvents = list.map(item => {
                    const dateStr = item.dateOfPublish || item.creationDate || item.scheduledDateTime || "";
                    return {
                        id: item.id,
                        name: item.title,
                        start: dateStr.replace("T", " ").substring(0, 16),
                        title: item.title,
                        titleEn: item.titleEn,
                        overview: item.overview,
                        overviewEn: item.overviewEn,
                        subTitle: item.subTitle,
                        subTitleEn: item.subTitleEn,
                        description: item.description,
                        descriptionEn: item.descriptionEn,
                        published: item.published,
                        actualityCategory: item.actualityCategory,
                        color: this.getEventColorForCategory(item.actualityCategory)
                    };
                });
            } catch (error) {
                console.error("Erreur lors de la récupération des événements du calendrier:", error);
            }
        },
        getEventColorForCategory(category) {
            const colors = {
                ARTICLE: "#4CAF50",
                DOSSIER: "#2196F3",
                PERSONNAGE: "#FF9800",
                PATRIMOINE: "#9C27B0",
                THEME: "#E91E63",
                DUAA: "#00BCD4",
                VERSET_DU_JOUR: "#00BCD4",
                LE_SAVIEZ_VOUS: "#8BC34A",
                HADITH_DU_JOUR: "#795548",
            };
            return colors[category] || "#1976D2";
        },

    },
    computed: {
        tagsfrList() {
            const rawFr = this.actualityInfo?.TagsTextFr || "";
            return rawFr
                ? rawFr.split(",").map((t) => t.trim()).filter(Boolean)
                : [];
        },
        tagsEnList() {
            const rawEn = this.actualityInfo?.TagsTextEn || "";
            return rawEn
                ? rawEn.split(",").map((t) => t.trim()).filter(Boolean)
                : [];
        },
        isReportByRequired() {
            return !!this.highlight || !!this.highlightEn;
        },
    },
    async created() {
        this.tagsArray = await FetchAllTags();

        this.isLoadingTables = true;
        this.actualityList = await FetchActualityByCategoryAndSubCategory(this.$route.params.category, this.$route.params.id);
        this.actualityList.forEach(item => {
            this.loadImage(item);
        });
        this.serie = await FetchSubCategoryById(this.$route.params.id);
        this.actualityWithoutSubCategoryList = await FetchActualityWithoutSubCategory();
        this.isLoadingTables = false;
    },
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>